module.exports = "https://static.wanderu.com/static/media/es.629aba7b.svg";